import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext({ hiddenPages: [], allPages: [], refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [hiddenPages, setHiddenPages] = useState([]);
  const [allPages, setAllPages] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings`);
      setHiddenPages(data.hidden_pages || []);
      setAllPages(data.all_pages || []);
    } catch (e) {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ hiddenPages, allPages, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
